module.exports = __webpack_public_path__ + "img/B800.05c5e450.jpg";